'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style", "data", "onEventDrop", "renderDragPreview"];
import * as React from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { disableNativeDragPreview } from '@atlaskit/pragmatic-drag-and-drop/element/disable-native-drag-preview';
import { useStableCallback } from '@base-ui/utils/useStableCallback';
import { useButton } from "../base-ui-copy/utils/useButton.mjs";
import { useRenderElement } from "../base-ui-copy/utils/useRenderElement.mjs";
import { useDragPreview } from "../internals/utils/useDragPreview.mjs";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StandaloneEvent = /*#__PURE__*/React.forwardRef(function StandaloneEvent(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      data,
      onEventDrop,
      renderDragPreview
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);

  // TODO: Expose a real `interactive` prop
  // to control whether the event should behave like a button
  const isInteractive = true;
  const ref = React.useRef(null);
  const {
    getButtonProps,
    buttonRef
  } = useButton({
    disabled: !isInteractive,
    native: false
  });
  const preview = useDragPreview({
    type: 'standalone-event',
    data,
    renderDragPreview,
    showPreviewOnDragStart: true
  });
  const state = React.useMemo(() => ({
    dragging: preview.state.isDragging
  }), [preview.state.isDragging]);
  const getDragData = useStableCallback(() => ({
    source: 'StandaloneEvent',
    eventData: data,
    onEventDrop,
    eventId: data.id,
    occurrenceKey: `external-${data.id}`
  }));
  React.useEffect(() => {
    return draggable({
      element: ref.current,
      getInitialData: getDragData,
      onGenerateDragPreview: ({
        nativeSetDragImage
      }) => {
        disableNativeDragPreview({
          nativeSetDragImage
        });
      },
      onDragStart: ({
        location
      }) => {
        preview.actions.onDragStart(location);
      },
      onDrag: ({
        location
      }) => {
        preview.actions.onDrag(location);
      },
      onDrop: () => {
        preview.actions.onDrop();
      }
    });
  }, [getDragData, preview.actions]);
  const element = useRenderElement('div', componentProps, {
    state,
    ref: [forwardedRef, buttonRef, ref],
    props: [elementProps, getButtonProps]
  });
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [element, preview.element]
  });
});
if (process.env.NODE_ENV !== "production") StandaloneEvent.displayName = "StandaloneEvent";